import React, { useState, useEffect } from 'react';
import { Link, navigate } from 'gatsby';
import { useAuth } from '../../../context/AuthContext'; // Ensure this is a named export
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'; // Added import for close icon
import { fetchUserAttributes } from 'aws-amplify/auth';
import gravatar from 'gravatar';
import './mobileNavbar.css';

const getRandomColor = () => {
  const letters = '0123456789ABC';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    const randomIndex = Math.floor(Math.random() * letters.length);
    color += letters[randomIndex];
  }
  // Check if the generated color is valid, else return a default color
  return color.length === 7 ? color : '#000000'; // Default to black if color generation fails
};

const MobileViewNavbar = () => {
  const { user, signOut } = useAuth();
  const [userAttribute, setUserAttribute] = useState(null);
  const [gravatarUrl, setGravatarUrl] = useState(null);
  const [showSignOut, setShowSignOut] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const togglePopup = () => {
    setIsPopupVisible(!isPopupVisible);
  };

  useEffect(() => {
    const loadUserAttributes = async () => {
      try {
        const attributes = await fetchUserAttributes();
        setUserAttribute(attributes);
        const userEmail = attributes.email;
        if (userEmail) {
          const firstLetter = userEmail.trim().toUpperCase().charAt(0);
          const bgColor = getRandomColor();
          const url = `https://ui-avatars.com/api/?name=${firstLetter}&size=80&background=${bgColor.slice(
            1
          )}&color=ffffff`;
          setGravatarUrl(url);
        }
      } catch (error) {
        console.error('Error fetching user attributes:', error);
      }
    };
    loadUserAttributes();
  }, []);

  const handleEngageClick = e => {
    e.preventDefault();
    navigate('/?elVideo=true'); // Navigate to the same page with elVideo=true
  };

  return (
    <nav className="navbar">
      <div className="navbarContainer">
        <Link to="/" className="navbarBrand engage-logo">
          <img
            src="../../images/EngageLogoUpdated.png"
            alt="KPOINT Logo"
            className="kpointLogo"
          />
        </Link>
        <div className="navbarLinks navBarContent">
          <div
            className="hamburgerMenu"
            style={{ width: '4rem' }}
            onClick={togglePopup}
          >
            <img src="../../images/hamberger.png" alt="Hamburger Menu" />
          </div>
        </div>
        {isPopupVisible && (
          <div className="popup">
            <div className="mobileHamburgerHeading">
              <img src="../../images/whiteEngageLogo.png" alt="KPOINT Logo" className="kpointLogo" />
              <button className="closePopup" onClick={togglePopup}>
                <FontAwesomeIcon icon={faTimesCircle} className='closeHamburger' />
              </button>
            </div>
            <ul>
              <li>
                <a
                  href="/?elVideo=true"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsPopupVisible(false); // Close popup
                    navigate('/?elVideo=true');

                  }}
                >
                  <FontAwesomeIcon icon={faPlay} className="elPlayIcon" />
                  Engage
                </a>
              </li>
              <li>
                <a
                  href="/case-studies"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsPopupVisible(false); // Close popup
                    navigate('/case-study');

                  }}
                >
                  Case Studies
                </a>
              </li>
              <li>
                <a
                  href="/interactivity"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsPopupVisible(false); // Close popup
                    navigate('/');
                  }}
                >
                  Interactivity
                </a>
              </li>
              <a
                href="https://kpoint.com/"
                onClick={(e) => {
                  e.preventDefault();
                  setIsPopupVisible(false); // Close popup
                  window.open('https://kpoint.com/', '_blank', 'noopener,noreferrer');
                }}
                className="contactus contactUsHamburger"
              >
                Contact Us
              </a>
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
};

export default MobileViewNavbar;
